import React from 'react';
import ToastConsumer from './toastConsumer';

const withToastManager = (Component) => (props) =>
  (
    <ToastConsumer>
      {(context) => <Component toastManager={context} {...props} />}
    </ToastConsumer>
  );

export default withToastManager;
